import container from "../../libs/container/container";

const amdAboutHeaderModule = (function () {
    const name = 'about__header-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutHeaderHeaderBigCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutHeaderImageCardLabelCls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdAboutHeaderModule;